module.exports = __webpack_public_path__ + "img/awards_image_23.51a22cad.jpg";